// extracted by mini-css-extract-plugin
export default {"centerStyle":"RemoveDirectFlights-module__centerStyle___tRycx","searchRemoveIcon":"RemoveDirectFlights-module__searchRemoveIcon___f18M0"};